import { apiHolder, apis, ReminderAction, } from 'api';
import moment from 'moment';
import lodashInRange from 'lodash/inRange';
import omit from 'lodash/omit';
import cloneDeepWith from 'lodash/cloneDeepWith';
import siriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { rangeInteract } from '../TimeLinePicker/util';
import { getDateTimeByFormWithZone, isCrossDay } from '../../util';
import { buildContactItem } from '@web-common/utils/contact_util';
import { getIn18Text } from 'api';
import { transContactModel2ContactItem } from '@web-common/components/util/contact';
import { EnmuRecurrenceRule, getInsertRecurrenceRule, parseRecurrenceRuleToFormRule } from './recurrence_rule_util';
export { EnmuRecurrenceRule, getInsertRecurrenceRule, parseRecurrenceRuleToFormRule };
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const catalogApi = apiHolder.api.requireLogicalApi(apis.catalogApiImpl);
const storeApi = apiHolder.api.getDataStoreApi();
export const loopRules = [
    {
        value: EnmuRecurrenceRule.NONE,
        label: getIn18Text('BUZHONGFU'),
    },
    {
        value: EnmuRecurrenceRule.DAYLY,
        label: getIn18Text('MEITIANZHONGFU'),
    },
    {
        value: EnmuRecurrenceRule.WEEKDAY,
        label: getIn18Text('MEIGEGONGZUORI'),
    },
    {
        value: EnmuRecurrenceRule.WEEKLY,
        label: getIn18Text('MEIZHOUZHONGFU'),
    },
    {
        value: EnmuRecurrenceRule.MONTHLY,
        label: getIn18Text('MEIYUEZHONGFU'),
    },
    {
        value: EnmuRecurrenceRule.YEARLY,
        label: getIn18Text('MEINIANZHONGFU'),
    },
    {
        value: EnmuRecurrenceRule.CUSTOM,
        label: getIn18Text('customRepeat'),
    },
];
export var EnmuReminders;
(function (EnmuReminders) {
    EnmuReminders[EnmuReminders["RT_MIN_5"] = 0] = "RT_MIN_5";
    EnmuReminders[EnmuReminders["RT_MIN_10"] = 1] = "RT_MIN_10";
    EnmuReminders[EnmuReminders["RT_MIN_30"] = 2] = "RT_MIN_30";
    EnmuReminders[EnmuReminders["RT_HOUR_1"] = 3] = "RT_HOUR_1";
    EnmuReminders[EnmuReminders["RT_HOUR_2"] = 4] = "RT_HOUR_2";
    EnmuReminders[EnmuReminders["RT_DAY_1"] = 5] = "RT_DAY_1";
    EnmuReminders[EnmuReminders["AT_CUR_8"] = 6] = "AT_CUR_8";
    EnmuReminders[EnmuReminders["AT_CUR_9"] = 7] = "AT_CUR_9";
    EnmuReminders[EnmuReminders["AT_PRE_1_9"] = 8] = "AT_PRE_1_9";
    EnmuReminders[EnmuReminders["AT_PRE_2_9"] = 9] = "AT_PRE_2_9";
})(EnmuReminders || (EnmuReminders = {}));
export var ReminderTimeUnit;
(function (ReminderTimeUnit) {
    ReminderTimeUnit[ReminderTimeUnit["MINUTE"] = 1] = "MINUTE";
    ReminderTimeUnit[ReminderTimeUnit["HOUR"] = 2] = "HOUR";
    ReminderTimeUnit[ReminderTimeUnit["DAY"] = 3] = "DAY";
    ReminderTimeUnit[ReminderTimeUnit["WEEK"] = 4] = "WEEK";
})(ReminderTimeUnit || (ReminderTimeUnit = {}));
export const TIME_REMINDER_MAP = {
    '1_5': EnmuReminders.RT_MIN_5,
    '1_10': EnmuReminders.RT_MIN_10,
    '1_30': EnmuReminders.RT_MIN_30,
    '2_1': EnmuReminders.RT_HOUR_1,
    '2_2': EnmuReminders.RT_HOUR_2,
    '3_1': EnmuReminders.RT_DAY_1,
    '3_1_9': EnmuReminders.AT_PRE_1_9,
    '3_2_9': EnmuReminders.AT_PRE_2_9,
    '3_0_8': EnmuReminders.AT_CUR_8,
    '3_0_9': EnmuReminders.AT_CUR_9,
};
export const DEFAULT_REMINDER = { action: 2, reminderAction: 1, interval: 5, timeUnit: 1, beforeOpt: 'before' };
export const DEFAULT_REMINDER_ALL_DAY = { action: 2, reminderAction: 1, interval: 1, timeUnit: 3, time: { hour: 8, min: 0, sec: 0 }, beforeOpt: 'before' };
export const REMINDER_ACTION_TEXT_MAP = {
    [ReminderAction.EMAIL_APP]: getIn18Text('YOUJIANJIYINGYONGNTX'),
    [ReminderAction.EMAIL]: getIn18Text('YOUJIANTIXING'),
    [ReminderAction.APP]: getIn18Text('YINGYONGNEITANKUANGTX'),
};
export const reminderActionOpts = () => {
    return [
        {
            value: ReminderAction.EMAIL_APP,
            label: getIn18Text('YOUJIANJIYINGYONGNTX'),
        },
        {
            value: ReminderAction.EMAIL,
            label: getIn18Text('YOUJIANTIXING'),
        },
        {
            value: ReminderAction.APP,
            label: getIn18Text('YINGYONGNEITANKUANGTX'),
        },
    ];
};
export const SCHEDULE_REMINDER_ACTION = 'ScheduleReminderAction';
export const getReminderByDefaultReminderAction = (isAllDay = false) => {
    const reminders = Object.assign({}, isAllDay ? DEFAULT_REMINDER_ALL_DAY : DEFAULT_REMINDER);
    const storeRes = storeApi.getSync(SCHEDULE_REMINDER_ACTION);
    reminders.reminderAction = Number(storeRes.suc ? storeRes.data : reminders.reminderAction);
    return reminders;
};
export const backfillReminder = (reminder, allDay) => {
    let res = EnmuReminders.RT_MIN_5;
    if (reminder) {
        const { timeUnit, interval, time = { hr: 0 } } = reminder;
        let key = `${timeUnit}_${interval}_${time === null || time === void 0 ? void 0 : time.hr}`;
        if (!allDay) {
            key = `${timeUnit}_${interval}`;
        }
        if (TIME_REMINDER_MAP[key]) {
            res = TIME_REMINDER_MAP[key];
        }
    }
    return res;
};
export const reminderTimeUnitOpts = allDay => {
    if (!allDay) {
        return [
            {
                value: ReminderTimeUnit.MINUTE,
                label: getIn18Text('FENZHONG'),
            },
            {
                value: ReminderTimeUnit.HOUR,
                label: getIn18Text('XIAOSHI'),
            },
            {
                value: ReminderTimeUnit.DAY,
                label: getIn18Text('TIAN'),
            },
        ];
    }
    else {
        return [
            {
                value: ReminderTimeUnit.DAY,
                label: getIn18Text('TIAN'),
            },
            {
                value: ReminderTimeUnit.WEEK,
                label: getIn18Text('ZHOU'),
            },
        ];
    }
};
export const reminderOpts = allDay => {
    if (!allDay) {
        return [
            {
                value: EnmuReminders.RT_MIN_5,
                label: getIn18Text('TIQIAN5FENZHONG'),
            },
            {
                value: EnmuReminders.RT_MIN_10,
                label: getIn18Text('TIQIAN10FEN'),
            },
            {
                value: EnmuReminders.RT_MIN_30,
                label: getIn18Text('TIQIAN30FEN'),
            },
            {
                value: EnmuReminders.RT_HOUR_1,
                label: getIn18Text('TIQIAN1XIAOSHI'),
            },
            {
                value: EnmuReminders.RT_HOUR_2,
                label: getIn18Text('TIQIAN2XIAOSHI'),
            },
            {
                value: EnmuReminders.RT_DAY_1,
                label: getIn18Text('TIQIAN1TIAN'),
            },
        ];
    }
    return [
        {
            value: EnmuReminders.AT_CUR_8,
            label: getIn18Text('DANGTIAN08:'),
        },
        {
            value: EnmuReminders.AT_CUR_9,
            label: getIn18Text('DANGTIAN09:'),
        },
        {
            value: EnmuReminders.AT_PRE_1_9,
            label: getIn18Text('TIQIAN1TIAN0'),
        },
        {
            value: EnmuReminders.AT_PRE_2_9,
            label: getIn18Text('TIQIAN2TIAN0'),
        },
    ];
};
export const getDefaultReminderOpts = allDay => {
    if (!allDay) {
        return [
            {
                value: EnmuReminders.RT_MIN_5,
                label: getIn18Text('TIQIAN5FENZHONG'),
            },
            {
                value: EnmuReminders.RT_MIN_10,
                label: getIn18Text('TIQIAN10FEN'),
            },
            {
                value: EnmuReminders.RT_MIN_30,
                label: getIn18Text('TIQIAN30FEN'),
            },
            {
                value: EnmuReminders.RT_HOUR_1,
                label: getIn18Text('TIQIAN1XIAOSHI'),
            },
            {
                value: EnmuReminders.RT_HOUR_2,
                label: getIn18Text('TIQIAN2XIAOSHI'),
            },
            {
                value: EnmuReminders.RT_DAY_1,
                label: getIn18Text('TIQIAN1TIAN'),
            },
        ];
    }
    return [
        {
            value: EnmuReminders.AT_CUR_8,
            label: getIn18Text('DANGTIAN08:'),
        },
        {
            value: EnmuReminders.AT_CUR_9,
            label: getIn18Text('DANGTIAN09:'),
        },
        {
            value: EnmuReminders.AT_PRE_1_9,
            label: getIn18Text('TIQIAN1TIAN0'),
        },
        {
            value: EnmuReminders.AT_PRE_2_9,
            label: getIn18Text('TIQIAN2TIAN0'),
        },
    ];
};
export const getInsertReminders = (t) => {
    const reminder = {
        action: 2,
        interval: 1,
        timeUnit: 1,
    };
    switch (t) {
        case EnmuReminders.RT_MIN_5:
            reminder.interval = 5;
            reminder.timeUnit = 1;
            break;
        case EnmuReminders.RT_MIN_10:
            reminder.interval = 10;
            reminder.timeUnit = 1;
            break;
        case EnmuReminders.RT_MIN_30:
            reminder.interval = 30;
            reminder.timeUnit = 1;
            break;
        case EnmuReminders.RT_HOUR_1:
            reminder.interval = 1;
            reminder.timeUnit = 2;
            break;
        case EnmuReminders.RT_HOUR_2:
            reminder.interval = 2;
            reminder.timeUnit = 2;
            break;
        case EnmuReminders.RT_DAY_1:
            reminder.interval = 1;
            reminder.timeUnit = 3;
            break;
        case EnmuReminders.AT_PRE_1_9:
            reminder.interval = 1;
            reminder.timeUnit = 3;
            reminder.time = {
                hr: 9,
                min: 0,
                sec: 0,
            };
            break;
        case EnmuReminders.AT_PRE_2_9:
            reminder.interval = 2;
            reminder.timeUnit = 3;
            reminder.time = {
                hr: 9,
                min: 0,
                sec: 0,
            };
            break;
        case EnmuReminders.AT_CUR_8:
            reminder.interval = 0;
            reminder.timeUnit = 3;
            reminder.time = {
                hr: 8,
                min: 0,
                sec: 0,
            };
            break;
        case EnmuReminders.AT_CUR_9:
            reminder.interval = 0;
            reminder.timeUnit = 3;
            reminder.time = {
                hr: 9,
                min: 0,
                sec: 0,
            };
            break;
        default:
            return null;
    }
    return reminder;
};
export const clazzMap = [
    {
        value: 0,
        label: getIn18Text('TONGGUISHURILI'),
        tipTitle: getIn18Text('ZUNXUNCIRLDGKFWSZDYG31'),
    },
    {
        value: 1,
        label: getIn18Text('GONGKAI'),
        tipTitle: getIn18Text('DINGYUEGAIRLDYHDNCKC4'),
    },
    {
        value: 2,
        label: getIn18Text('BUGONGKAI'),
        tipTitle: getIn18Text('DINGYUEGAIRLDYHWFCKC19'),
    },
];
export const busyStatus = [
    {
        value: 0,
        label: getIn18Text('MANGLU'),
        tipTitle: getIn18Text('GAIRICHENGZJSJDDWHZS3'),
    },
    {
        value: 1,
        label: getIn18Text('KONGXIAN'),
        tipTitle: getIn18Text('GAIRICHENGZJSJDDWHZS3xiog9l'),
    },
];
export const valiteMoment = (moments, desc = getIn18Text('JIESHUSHIJIANBU')) => {
    const { startDate, endDate, startTime, endTime } = moments;
    if (startDate === null || endDate === null) {
        siriusMessage.error({ content: getIn18Text('QINGXUANZESHIJIAN') });
        return false;
    }
    const startIsCrossDay = moment.isMoment(startTime) ? isCrossDay(startDate, startTime) : false;
    const endIsCrossDay = moment.isMoment(endTime) ? isCrossDay(endDate, endTime) : false;
    const _start = (startIsCrossDay ? startTime : startDate);
    const _end = (endIsCrossDay ? endTime : endDate);
    const start = _start
        .clone()
        .hours(startTime ? startTime.hours() : 0)
        .minutes(startTime ? startTime.minutes() : 0)
        .seconds(startTime ? startTime.seconds() : 0);
    const end = _end
        .clone()
        .hours(endTime ? endTime.hours() : 0)
        .minutes(endTime ? endTime.minutes() : 0)
        .seconds(endTime ? endTime.seconds() : 0);
    if (end.diff(start) < 0) {
        siriusMessage.error({ content: desc });
        return false;
    }
    return true;
};
export const generateTimeRange = (timeline, startAxis, interval, date) => timeline.map((status, index) => {
    const start = moment(date)
        .startOf('days')
        .hours(startAxis)
        .minutes(index * interval * 60);
    const end = start.clone().add(interval, 'hours');
    return {
        range: [start, end],
        occupied: status === 1,
        valited: status === 0,
        expired: status === 2,
    };
});
export const getSeqNo = (time, interval) => {
    const hours = time.hours();
    const minutes = time.minutes();
    const index = Math.floor((hours + minutes / 60) / interval);
    return index;
};
export const getMatchedRoom = ({ room4MatchList, formStartTime, formEndTime, }) => {
    if (room4MatchList === undefined || room4MatchList.length === 0) {
        return [];
    }
    const list = [];
    room4MatchList.forEach(roomInfo => {
        const { roomBookInfoVO: { time_axis, interval, start, end, }, } = roomInfo;
        const rangeStart = formStartTime.clone().startOf('day').hours(start);
        const rangeEnd = rangeStart.clone().hours(end);
        if (formStartTime.isBefore(rangeStart) || formEndTime.isBefore(rangeStart) || formStartTime.isAfter(rangeEnd) || formEndTime.isAfter(rangeEnd)) {
            return;
        }
        let interact = false;
        for (let index = 0; index < time_axis.length; index++) {
            if (time_axis[index] !== 0) {
                const invaliteStart = formStartTime
                    .clone()
                    .startOf('day')
                    .hours(start + index / 2)
                    .minutes((index % (1 / interval)) * interval * 60);
                const invaliteEnd = invaliteStart.clone().add(interval * 60, 'minutes');
                if (rangeInteract([invaliteStart, invaliteEnd], [formStartTime, formEndTime])) {
                    interact = !0;
                    break;
                }
            }
        }
        if (!interact) {
            list.push({
                roomInfo,
            });
        }
    });
    return list;
};
export const resetMomentToHourOrHalfHour = (time, tail = false) => {
    if (moment.isMoment(time)) {
        const compareTime = time.clone().startOf('minutes');
        const startHourTime = moment(compareTime).startOf('hours');
        const startQuarterTime = moment(compareTime).minutes(15);
        const middleHourTime = moment(compareTime).minutes(30);
        const threeQuarterTime = moment(compareTime).minutes(45);
        const endHourTime = compareTime.hours() !== 23 ? moment(compareTime).add(1, 'hours').startOf('hours') : compareTime;
        if (tail) {
            if (compareTime.isBetween(startHourTime, startQuarterTime)) {
                return startQuarterTime;
            }
            else if (compareTime.isBetween(startQuarterTime, middleHourTime)) {
                return middleHourTime;
            }
            else if (compareTime.isBetween(middleHourTime, threeQuarterTime)) {
                return threeQuarterTime;
            }
            else if (compareTime.isBetween(threeQuarterTime, endHourTime)) {
                return endHourTime;
            }
            return compareTime;
        }
        if (compareTime.isBetween(startHourTime, startQuarterTime)) {
            return startHourTime;
        }
        else if (compareTime.isBetween(startQuarterTime, middleHourTime)) {
            return startQuarterTime;
        }
        else if (compareTime.isBetween(middleHourTime, threeQuarterTime)) {
            return middleHourTime;
        }
        else if (compareTime.isBetween(threeQuarterTime, endHourTime)) {
            return threeQuarterTime;
        }
    }
    return time;
};
export const serializeFormMoments = (values, dese = false) => {
    const customizer = (pv) => {
        if (pv) {
            if (dese && pv instanceof Date) {
                return moment(pv);
            }
            if (!dese && moment.isMoment(pv)) {
                return pv.toDate();
            }
            return undefined;
        }
        return pv;
    };
    if (typeof values === 'object') {
        return cloneDeepWith(values, customizer);
    }
    return values;
};
export const getContanctObjs = async (emails) => {
    const data = await contactApi.doGetContactByEmailFilter({ emails });
    const res = [];
    emails.forEach(email => {
        const contact = data[email];
        if (contact) {
            res.push(transContactModel2ContactItem(contact));
        }
        else {
            res.push(buildContactItem({ item: email, email, name: email, type: '' }));
        }
    });
    return res;
};
export const isWeekday = (t) => lodashInRange(t.day(), 1, 6);
export const handleMeetingFormTimeRange = (values) => {
    const { startDate, startTime, endDate, endTime, allDay } = values;
    const formStartDate = moment.isMoment(startDate) ? startDate.clone() : moment();
    const formStartTime = resetMomentToHourOrHalfHour(moment.isMoment(startTime) ? startTime === null || startTime === void 0 ? void 0 : startTime.clone() : formStartDate.clone());
    const formEndDate = moment.isMoment(endDate) ? endDate === null || endDate === void 0 ? void 0 : endDate.clone() : moment();
    const formEndTime = resetMomentToHourOrHalfHour(moment.isMoment(endTime) ? endTime === null || endTime === void 0 ? void 0 : endTime.clone() : formEndDate === null || formEndDate === void 0 ? void 0 : formEndDate.clone(), !0);
    if (allDay) {
        formStartTime.hours(7).startOf('hours');
        formEndTime.hours(23).startOf('hours');
    }
    if (isCrossDay(formStartDate, formEndDate)) {
        formEndDate.set({
            year: formStartDate.year(),
            month: formStartDate.month(),
            date: formStartDate.date(),
        });
        formEndTime.hours(23).startOf('hours');
    }
    formStartTime.set({
        year: formStartDate.year(),
        month: formStartDate.month(),
        date: formStartDate.date(),
    });
    formEndTime.set({
        year: formEndDate.year(),
        month: formEndDate.month(),
        date: formEndDate.date(),
    });
    if (formEndTime.isBefore(formStartTime)) {
        formEndTime.endOf('day');
    }
    return {
        formStartDate,
        formStartTime,
        formEndDate,
        formEndTime,
    };
};
export const handleMeetingFormTimeRangeNew = async (values) => {
    const { startDate, startTime, endDate, endTime, allDay, zoneId: _zoneId } = values;
    let formStartDate = moment.isMoment(startDate) ? startDate.clone() : moment();
    const formStartTime = resetMomentToHourOrHalfHour(moment.isMoment(startTime) ? startTime === null || startTime === void 0 ? void 0 : startTime.clone() : formStartDate.clone());
    let formEndDate = moment.isMoment(endDate) ? endDate === null || endDate === void 0 ? void 0 : endDate.clone() : moment();
    const formEndTime = resetMomentToHourOrHalfHour(moment.isMoment(endTime) ? endTime === null || endTime === void 0 ? void 0 : endTime.clone() : formEndDate === null || formEndDate === void 0 ? void 0 : formEndDate.clone(), !0);
    formStartDate = formStartTime.clone();
    formEndDate = formEndTime.clone();
    let zoneId = _zoneId;
    if (!zoneId) {
        zoneId = await catalogApi.getZoneId();
    }
    const zoneList = await catalogApi.getZoneList();
    const start = getDateTimeByFormWithZone(formStartDate, formStartTime, !!allDay, zoneId, zoneList);
    const end = getDateTimeByFormWithZone(formEndDate, formEndTime, !!allDay, zoneId, zoneList);
    if (!!allDay) {
        start.hr = 7;
        start.min = 0;
        start.sec = 0;
        end.hr = 23;
        end.min = 0;
        end.sec = 0;
    }
    if (!(start.y == end.y && start.d == end.d && start.m == end.m)) {
        end.y = start.y;
        end.m = start.m;
        end.d = start.d;
        end.hr = 23;
        end.min = 0;
        end.sec = 0;
    }
    if (end.hr < start.hr || (end.hr == start.hr && end.min < start.min)) {
        end.hr = 23;
        end.min = 59;
        end.sec = 59;
    }
    let gmt = 'GMT+08:00';
    const zone = zoneList.find(i => i.id === zoneId);
    if (zone) {
        const reg = /\((.+?)\)/gi;
        const arr = zone.content.match(reg);
        if (arr && arr.length) {
            gmt = arr[0].replace('(', '').replace(')', '');
            if (gmt === 'GMTZ') {
                gmt = 'GMT+00:00';
            }
        }
    }
    const resultMoment = {
        formStartDate: moment(`${start.y}/${start.m}/${start.d} ${start.hr}:${start.min}:${start.sec} ${gmt}`),
        formStartTime: moment(`${start.y}/${start.m}/${start.d} ${start.hr}:${start.min}:${start.sec} ${gmt}`),
        formEndDate: moment(`${end.y}/${end.m}/${end.d} ${end.hr}:${end.min}:${end.sec} ${gmt}`),
        formEndTime: moment(`${end.y}/${end.m}/${end.d} ${end.hr}:${end.min}:${end.sec} ${gmt}`),
    };
    const originStart = Object.assign({}, start);
    const originEnd = Object.assign({}, end);
    if (!!allDay) {
        end.d = end.d + 1;
        start.hr = 0;
        start.min = 0;
        start.sec = 0;
        end.hr = 0;
        end.min = 0;
        end.sec = 0;
    }
    return Object.assign(Object.assign({}, resultMoment), { start,
        end,
        originStart,
        originEnd });
};
export const constructAvailableMeetingRoomParam = async (formValue, event) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!formValue) {
        return null;
    }
    const { enmuRecurrenceRule, moments, time: { allDay }, zoneId: _zoneId, } = formValue;
    let recurrenceRule;
    if (enmuRecurrenceRule !== undefined && enmuRecurrenceRule !== EnmuRecurrenceRule.NONE) {
        recurrenceRule = getInsertRecurrenceRule(formValue);
        if (!recurrenceRule && ((_a = event === null || event === void 0 ? void 0 : event.scheduleInfo) === null || _a === void 0 ? void 0 : _a.recur)) {
            recurrenceRule = Object.assign(Object.assign({}, omit(event.scheduleInfo.recur, 'recurIntro')), { freq: ((_b = event.scheduleInfo.recur) === null || _b === void 0 ? void 0 : _b.freq) || ((_c = event.scheduleInfo.recur) === null || _c === void 0 ? void 0 : _c.frequency), userFreq: ((_d = event.scheduleInfo.recur) === null || _d === void 0 ? void 0 : _d.userFreq) || ((_e = event.scheduleInfo.recur) === null || _e === void 0 ? void 0 : _e.userFrequency) });
        }
    }
    let zoneId = _zoneId;
    if (!zoneId) {
        zoneId = await catalogApi.getZoneId();
    }
    const { start, end } = await handleMeetingFormTimeRangeNew(Object.assign(Object.assign({}, moments), { allDay: !!allDay, zoneId }));
    const condtion = {
        time: {
            allDay: allDay ? 1 : 0,
            start,
            end,
            startZoneId: zoneId,
            endZoneId: zoneId,
        },
        addr: '',
        capacity_code: 0,
        instruments: [],
        page: 1,
        page_size: 999,
    };
    if (recurrenceRule) {
        condtion.time.recurrenceRule = recurrenceRule;
    }
    if (event && ((_f = event.scheduleInfo.meetingInfo) === null || _f === void 0 ? void 0 : _f.order_id)) {
        condtion.order_id = (_g = event.scheduleInfo.meetingInfo) === null || _g === void 0 ? void 0 : _g.order_id;
    }
    return condtion;
};
export const initDefaultMoment = (date) => {
    const cur = moment();
    const startMoment = date ? date.clone() : cur;
    startMoment.second(0).millisecond(0);
    startMoment.minutes(startMoment.minutes() > 30 ? 60 : 30);
    const endMoment = startMoment.clone().add(1, 'hour');
    return {
        startDate: startMoment,
        startTime: startMoment.clone(),
        endDate: endMoment,
        endTime: endMoment.clone(),
    };
};
